<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>

<form #form="ngForm" [formGroup]="requestForm" class="form-field-full">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader"><mat-icon>search</mat-icon> Search Wells & Samples</h2>
    </div>
  </div>
  <div fxLayout="row wrap" class="matero-row">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>OHA Well Id</mat-label>
              <input id="wellId" name="wellId" formControlName="wellId" matInput matTooltipClass="tooltip" matTooltip="OHA Well Id is a number generated by the system when a new Well is added" />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Sample Id</mat-label>
              <input id="sampleId" name="sampleId" formControlName="sampleId" matInput matTooltipClass="tooltip"
                matTooltip="Sample Id is a number generated by the system when a new Sample is added. Sample's are associated or tied to a specific Well" />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Well Log</mat-label>
              <input id="wellId" name="wellLog" formControlName="wellLog" matInput matTooltipClass="tooltip"
                matTooltip="This is a combination of county name and numbers; for example, a well log in Marion County could be MARI-12345" />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Well Tag</mat-label>
              <input id="wellTag" name="wellTag" formControlName="wellTag" matInput matTooltipClass="tooltip"
                matTooltip="Well label/tag number (L-#####). Wells built after 1996 should have a metal well tag on or near the wellhead" />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard" style="width:100%;">
              <mat-label>Address</mat-label>
              <input id="address" name="address" formControlName="address" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>City</mat-label>
              <input id="city" name="city" formControlName="city" matInput />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Zip</mat-label>
              <input id="zip" name="zip" formControlName="zip" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>County</mat-label>
              <mat-select id="county" name="county" formControlName="county">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
    </div>
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Contaminant</mat-label>
              <mat-select id="contaminant" name="contaminant" multiple formControlName="contaminant">
                <mat-option *ngFor="let item of oregonWellDataService.contaminants" value="{{item.value}}">{{item.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxFlex="50" fxFlex.lt-sm="100">

            <mat-form-field appearance="standard">
              <mat-label>Voucher Identifier</mat-label>
              <input id="voucherIdentifier" name="voucherIdentifier" formControlName="voucherIdentifier" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <div *ngIf="showVoucherType == true">
              <mat-form-field appearance="standard">
                <mat-label>Voucher Type</mat-label>
                <mat-select id="voucherType" name="voucherType" formControlName="voucherType">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let item of voucherService.types" value="{{item}}">{{item}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Analysis Start Date</mat-label>
              <input id="startDate" name="startDate" formControlName="startDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepicker" />
              <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Analysis End Date</mat-label>
              <input id="endDate" name="endDate" formControlName="endDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerEnd" />
              <mat-datepicker-toggle matSuffix [for]="datepickerEnd"></mat-datepicker-toggle>
              <mat-datepicker #datepickerEnd>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Sample Start Date</mat-label>
              <input id="createStartDate" name="createStartDate" formControlName="createStartDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerCreateStart" />
              <mat-datepicker-toggle matSuffix [for]="datepickerCreateStart"></mat-datepicker-toggle>
              <mat-datepicker #datepickerCreateStart>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Sample End Date</mat-label>
              <input id="createEndDate" name="createEndDate" formControlName="createEndDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerCreateEnd" />
              <mat-datepicker-toggle matSuffix [for]="datepickerCreateEnd"></mat-datepicker-toggle>
              <mat-datepicker #datepickerCreateEnd>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Created Start Date</mat-label>
              <input id="receivedStartDate" name="receivedStartDate" formControlName="receivedStartDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerReceivedStart" />
              <mat-datepicker-toggle matSuffix [for]="datepickerReceivedStart"></mat-datepicker-toggle>
              <mat-datepicker #datepickerReceivedStart>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Created End Date</mat-label>
              <input id="receivedEndDate" name="receivedEndDate" formControlName="receivedEndDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerReceivedEnd" />
              <mat-datepicker-toggle matSuffix [for]="datepickerReceivedEnd"></mat-datepicker-toggle>
              <mat-datepicker #datepickerReceivedEnd>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </mat-card>
    </div>
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        View Results By:&nbsp;&nbsp;
        <mat-radio-group aria-label="View Results By" formControlName="searchBy">
          <mat-radio-button value="Well" (click)="searchByChange('Well')">Well</mat-radio-button>
          <mat-radio-button value="Sample" (click)="searchByChange('Sample')">Sample</mat-radio-button>
        </mat-radio-group>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonSearch" (click)="onSubmit()" mat-raised-button color="primary" title="Search" [disabled]='processing'>Search</button>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonReset" (click)="reset()" mat-raised-button color="basic" title="Clear" [disabled]='processing'>Clear</button>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonDownload" (click)="download()" mat-raised-button color="accent" title="Download All"
          [disabled]='authService.isReadOnly() || !showResults || processing || searchResultsCount <= 0'>Download All</button>
        &nbsp;&nbsp;
        <button type="submit" id="mergeWellButtonDownload" (click)="openMergeWellDialog()" mat-raised-button color="warn" title="Merge Wells"
          [disabled]='authService.isReadOnly() || !showResults || processing || searchResultsCount <= 0 || checkboxActionList.length <= 1 || oregonWellDataService.search.searchBy != "Well"'><mat-icon
            class="icon-20">merge_type</mat-icon> Merge Wells</button>
      </mat-card>
    </div>
  </div>
</form>

<mat-card [hidden]="!showResults">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">{{oregonWellDataService.search.searchBy}} Results ({{searchResultsCount}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTable($event)" placeholder="Filter Results" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-row>{{oregonWellDataService.search.searchBy}} Results ({{searchResultsCount}})</mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="selectRow">
        <mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="oregonWellDataService.search.searchBy !== 'Well'"></mat-header-cell>
        <mat-cell *matCellDef="let result" [hidden]="oregonWellDataService.search.searchBy !== 'Well'">
          <input type="checkbox" (click)="clickCheckboxAction(result.wellId)" [hidden]="oregonWellDataService.search.searchBy !== 'Well'" />
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellId">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left:5px">OHA Well Id</mat-header-cell>
        <mat-cell *matCellDef="let result" style="padding-left:5px">
          <a [routerLink]="['/well/edit/', result.wellId]" title="Edit Well {{result.wellId}}">{{result.wellId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="sampleId">
        <mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="oregonWellDataService.search.searchBy!=='Sample'">Sample Id</mat-header-cell>
        <mat-cell *matCellDef="let result" [hidden]="oregonWellDataService.search.searchBy!=='Sample'">
          <a href="javascript:void(0)" (click)="editSample(result.sampleId)" title="Edit Sample {{result.sampleId}}">{{result.sampleId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="voucherId">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="12" fxFlex.lt-sm="100" [hidden]="oregonWellDataService.search.searchBy!=='Sample'">Voucher Id</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="12" fxFlex.lt-sm="100" [hidden]="oregonWellDataService.search.searchBy!=='Sample'">
          <a href="javascript:void(0)" (click)="editVoucher(result.voucherOhaId)" title="Edit Voucher {{result.voucherId}}">{{result.voucherId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="voucherType">
        <mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="oregonWellDataService.search.searchBy!=='Sample'">Voucher Type</mat-header-cell>
        <mat-cell *matCellDef="let result" [hidden]="oregonWellDataService.search.searchBy!=='Sample'">
          {{result.voucherType}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellAddress1">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Address</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellAddress1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCity">
        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellCity}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellZip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellZip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCounty">
        <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellCounty}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellLog">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Log</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellLog}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellTag">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Tag</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellTag}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="score">
        <mat-header-cell *matHeaderCellDef mat-sort-header>% Match</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.score}}
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>